import Vuex from 'vuex'
import {vuexUser, vuexToken} from '@/plugins/vuex-persistedstate'

import auth from './auth'
import mapplantsFiltriCensimento from './mapplants/mapplants-filtri-censimento'
import mapplantsFiltriManutenzione from './mapplants/mapplants-filtri-manutenzione'
import mapplantsInterventiEseguiti from './mapplants/mapplants-admin'
import mapplantsMappa from './mapplants/mapplants-mappa'
import modal from './modal'
import reportAdmin from './report/report-admin'
import reportFiltriSegnalazione from './report/report-filtri-segnalazione'
import reportMappa from './report/report-mappa'
import mapplantsPuntiDiInteresse from './mapplants/mapplants-punti-di-interesse'
import upload from './upload'
import user from './user'
// punti luce
import puntiluceMappa from './puntiluce/puntiluce-mappa'

export default new Vuex.Store({
    plugins: [vuexUser, vuexToken],
    modules: {
        auth,
        mapplantsInterventiEseguiti,
        mapplantsFiltriCensimento,
        mapplantsFiltriManutenzione,
        mapplantsMappa,
        modal,
        reportAdmin,
        reportFiltriSegnalazione,
        reportMappa,
        mapplantsPuntiDiInteresse,
        user,
        upload,
        puntiluceMappa
    }
})
